/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { FormCity } from './FormCity';
import type { Countries } from './Countries';
import type { FormCountry } from './FormCountry';
import type { InAppSignup } from './InAppSignup';
import type { FormLanguage } from './FormLanguage';

export interface GetDriverRegistrationFormDataResponse {
    cities: Array<FormCity>;
    languages: Array<FormLanguage>;
    cities_by_countries: Array<FormCountry>;
    terms_consent_required: Array<Countries>;
    in_app_signup: InAppSignup;
}
